/* Just The Fun Part — theme behaviors
   Ported from the prototype (app.jsx reveal-on-scroll, components.jsx header/cart)
   against Shopify's AJAX Cart + Section Rendering APIs. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveal on scroll (app.jsx) ---------- */
  function initReveal() {
    if (reduced) {
      document.querySelectorAll('.jtfp-fade-up').forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    document.querySelectorAll('.jtfp-fade-up:not(.in)').forEach(function (el) { io.observe(el); });
  }

  /* ---------- header solidify after 12px (components.jsx Header) ---------- */
  function initHeader() {
    var hdr = document.querySelector('.jtfp-hdr');
    if (!hdr) return;
    var onScroll = function () { hdr.classList.toggle('solid', window.scrollY > 12); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    var burger = hdr.querySelector('.jtfp-burger');
    var drawer = hdr.querySelector('.jtfp-drawer-nav');
    if (burger && drawer) {
      burger.addEventListener('click', function () { drawer.classList.toggle('show'); });
    }
  }

  /* ---------- accordions (.jtfp-acc, grid-template-rows animation) ---------- */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('.jtfp-acc__head');
    if (!head) return;
    var acc = head.closest('.jtfp-acc');
    acc.classList.toggle('open');
    var icon = head.querySelector('.jtfp-acc__icon');
    if (icon) icon.textContent = acc.classList.contains('open') ? '–' : '+';
  });

  /* ---------- qty steppers (event delegation) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.jtfp-qty [data-qty]');
    if (!btn) return;
    var input = btn.parentNode.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value || '1', 10) + parseInt(btn.dataset.qty, 10);
    input.value = Math.max(parseInt(input.min || '0', 10), v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- cart drawer ---------- */
  var drawerEl = function () { return document.getElementById('JtfpCartDrawer'); };
  function openCart() {
    var d = drawerEl(); if (!d) return;
    d.querySelector('.jtfp-cart').classList.add('show');
    d.querySelector('.jtfp-scrim').classList.add('show');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeCart() {
    var d = drawerEl(); if (!d) return;
    d.querySelector('.jtfp-cart').classList.remove('show');
    d.querySelector('.jtfp-scrim').classList.remove('show');
    document.documentElement.style.overflow = '';
  }
  window.jtfpOpenCart = openCart;

  function refreshCart(openAfter) {
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + '?sections=jtfp-cart-drawer' : '/?sections=jtfp-cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['jtfp-cart-drawer'];
        if (!html) return;
        var d = drawerEl(); if (!d) return;
        var wasOpen = d.querySelector('.jtfp-cart').classList.contains('show');
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#JtfpCartDrawer');
        if (fresh) d.innerHTML = fresh.innerHTML;
        document.querySelectorAll('[data-jtfp-cart-count]').forEach(function (el) {
          var n = parseInt(d.querySelector('[data-cart-count]')?.dataset.cartCount || '0', 10);
          el.textContent = n;
          el.hidden = n === 0;
        });
        if (wasOpen || openAfter) openCart();
      });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-jtfp-cart-open]')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-jtfp-cart-close]') || (e.target.classList && e.target.classList.contains('jtfp-scrim'))) {
      e.preventDefault(); closeCart();
    }
    var remove = e.target.closest('[data-jtfp-line-remove]');
    if (remove) {
      e.preventDefault();
      changeLine(remove.dataset.jtfpLineRemove, 0);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

  function changeLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { refreshCart(false); });
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-jtfp-line-qty]');
    if (!input) return;
    changeLine(input.dataset.jtfpLineQty, parseInt(input.value || '0', 10));
  });

  /* ---------- AJAX add-to-cart: any form[data-jtfp-ajax] ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-jtfp-ajax]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { return refreshCart(true); })
      .catch(function () { if (form.submit) HTMLFormElement.prototype.submit.call(form); })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label; }
        if (typeof form.dispatchEvent === 'function') form.dispatchEvent(new CustomEvent('jtfp:added', { bubbles: true }));
      });
  });

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initHeader();
  });
})();
